import ServicesTile from "Components/ServicesTile/ServicesTile";
import HomeBanner from "../HomeBanner/HomeBanner";
import Meta from "../Meta/Meta";

const Home = () => {
  return (
    <>
      <Meta
        title="ALGermanist - Home Page"
        description="Welcome to ALGermanist, your go-to platform for learning German. Explore our courses and resources."
        keywords="German learning, language courses, ALGermanist"
      />
      <HomeBanner />
      <ServicesTile />
    </>
  );
};

export default Home;
